import { render } from "./SocialMediaPanel.vue?vue&type=template&id=e025de92&scoped=true"
import script from "./SocialMediaPanel.vue?vue&type=script&lang=js"
export * from "./SocialMediaPanel.vue?vue&type=script&lang=js"

import "./SocialMediaPanel.vue?vue&type=style&index=0&id=e025de92&scoped=true&lang=css"

import exportComponent from "/home/runner/work/joshpotterton.com/joshpotterton.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e025de92"]])

export default __exports__